const BASE_URL = "https://www.martinpro-me.com/api/";

export default BASE_URL;